import type { LucideIcon } from 'lucide-react'

import {
    BookOpen,
    CalendarRange,
    ChartLine,
    ClipboardCheck,
    FileChartColumn,
    FileText,
    History,
    LayoutDashboard,
    NotebookPen,
    Settings,
    Users
} from 'lucide-react'

export type NavItem = {
    href: string
    label: string
    icon: LucideIcon
    match: string[]
    adminOnly?: boolean
}

export type NavGroup = {
    label: string
    items: NavItem[]
}

export const NAV_GROUPS: NavGroup[] = [
    {
        label: 'Ringkasan',
        items: [
            { href: '/', label: 'Dashboard', icon: LayoutDashboard, match: ['/'] }
        ]
    },
    {
        label: 'Data Sekolah',
        items: [
            { href: '/mapel', label: 'Mata Pelajaran', icon: BookOpen, match: ['/mapel'] },
            { href: '/siswa', label: 'Siswa', icon: Users, match: ['/siswa'] }
        ]
    },
    {
        label: 'Akademik',
        items: [
            { href: '/absen', label: 'Absen', icon: ClipboardCheck, match: ['/absen'] },
            { href: '/jurnal', label: 'Jurnal Mengajar', icon: NotebookPen, match: ['/jurnal'] },
            { href: '/nilai', label: 'Penilaian', icon: ChartLine, match: ['/nilai'] }
        ]
    },
    {
        label: 'Laporan',
        items: [
            { href: '/preview', label: 'Preview Absen & Penilaian', icon: FileText, match: ['/preview', '/laporan-harian'] },
            { href: '/rekap', label: 'Rekap', icon: FileChartColumn, match: ['/rekap'] }
        ]
    },
    {
        label: 'Administrasi',
        items: [
            { href: '/tahun-ajaran', label: 'Tahun Ajaran', icon: CalendarRange, match: ['/tahun-ajaran'], adminOnly: true },
            { href: '/aktivitas', label: 'Log Aktivitas', icon: History, match: ['/aktivitas'], adminOnly: true },
            { href: '/pengaturan', label: 'Pengaturan', icon: Settings, match: ['/pengaturan'] }
        ]
    }
]

export const PAGE_TITLES: Record<string, string> = {
    '/': 'Dashboard',
    '/mapel': 'Mata Pelajaran',
    '/siswa': 'Siswa',
    '/absen': 'Absen',
    '/jurnal': 'Jurnal Mengajar',
    '/nilai': 'Penilaian',
    '/preview': 'Preview Absen & Penilaian',
    '/laporan-harian': 'Preview Absen & Penilaian',
    '/rekap': 'Rekap Akademik',
    '/tahun-ajaran': 'Tahun Ajaran',
    '/aktivitas': 'Log Aktivitas',
    '/pengaturan': 'Pengaturan'
}
